import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import { IntlProvider } from 'react-intl';
import App from './App';
import store from './store';
import client from './apollo';
import registerServiceWorker from './registerServiceWorker';
import validatorAttributeFormatter from './validatorAttributeFormatter';
import './assets/react-datepicker-fix.css';
import './assets/semantic-ui-fix.css';

const container = document.getElementById('ds-admin-root');
const root = createRoot(container);

root.render(
  <IntlProvider locale='en'>
    <Provider store={store}>
      <ApolloProvider client={client}>
        <HashRouter>
          <App />
        </HashRouter>
      </ApolloProvider>
    </Provider>
  </IntlProvider>
);
registerServiceWorker();
validatorAttributeFormatter();
